<template>
    <p class="smallTitle">
        <span></span>{{title}}
    </p>
</template>
<script>
    export default {
        props: ['title'],
        components: {
        },
        data() {
            return {}
        }
    }
</script>
<style scoped lang="less">

</style>